module.exports = __webpack_public_path__ + "img/group-2990@2x.1703795f.jpg";